import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ValidatorRemoteService } from '../../services/validator-remote.service';
import {
  ControlValidatorType,
  ControlValidateMoment,
  ControlValidatorError,
  ControlValidatorAsync
} from '../../types/validator.types';
import { ControlModelPropertyEnum } from '../../types/control-model-property';

@Injectable()
export class UniqueControlValidator extends ControlValidatorAsync {
  type = ControlValidatorType.Unique;
  validateMoment = ControlValidateMoment.Change;
  // subject = new Subject<ControlValidatorError>();
  validateAsync(): Observable<ControlValidatorError> {
    this.error = new ControlValidatorError(false, 'å¯ä¸æ§éªè¯ä¸­...');
    const subject = new Subject<ControlValidatorError>();
    this.validateUnique(subject);
    return subject;
  }
  constructor(private service: ValidatorRemoteService) {
    super();
  }

  private next(subject: Subject<ControlValidatorError>, error: ControlValidatorError) {
    this.error = error;
    subject.next(error);
    subject.complete();
  }

  private dataSourceKey = ControlModelPropertyEnum.AssociatedEntities;
  private dataMemberKey = ControlModelPropertyEnum.EntityAttribute;

  private validateUnique(subject: Subject<ControlValidatorError>) {
    // å¤æ­æ¯å¦å³èå±æ§
    const dataSource = this.control.model[this.dataSourceKey];
    const dataMember = this.getDataMember();
    if (!dataSource || !dataMember) {
      this.next(subject, new ControlValidatorError(true, ''));
      return;
    }
    const value = this.control.model.value;
    if (!value) {
      if (typeof value !== 'number') {
        this.next(subject, new ControlValidatorError(true, ''));
        return;
      }
    }
    // è¯·æ±åç«¯éªè¯å°å
    // è¿åç»æåè¶æ¶å¤ç
    // å¤çå¼æ­¥çé®é¢
    this.validateUniqueRemote(dataSource, dataMember)
      .pipe(finalize(() => {}))
      .subscribe(
        (s) => {
          if (s.ok) {
            this.next(subject, new ControlValidatorError(true, ''));
          } else {
            this.next(subject, new ControlValidatorError(false, 'æ°æ®éå¤'));
          }
        },
        (error) => {
          this.next(subject, new ControlValidatorError(false, 'æ°æ®éªè¯éå¤éè¯¯'));
        }
      );
  }

  /**
   * è·åå³èå®ä½å±æ§åç§°
   *
   */
  private getDataMember() {
    let dataMember = this.control.model[this.dataMemberKey];
    if (this.control.model.associatedEntityAttributes) {
      const attribute = this.control.model.associatedEntityAttributes.find((s) => s.source === '');
      if (attribute) {
        dataMember = attribute.target;
      } else {
        dataMember = undefined;
      }
    }
    return dataMember;
  }

  private validateUniqueRemote(dataSource: string, dataMember: string): Observable<any> {
    const value = this.control.model.value;
    return this.service.validateUnique(value, dataSource, dataMember, this.control.dataConfig);
  }
}
